import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

 const StyledBox = styled(Box)(({ theme }) => ({
 backgroundColor: theme.palette.background.secondary,
 padding :theme.spacing(16, 0),
  [theme.breakpoints.down('lg')]: {
   padding :theme.spacing(8, 0),
  },
}));
export default StyledBox;